import clsx from 'clsx'
import Caption from 'LuxKit/Typography/Caption'
import noop from 'lib/function/noop'
import { rem } from 'polished'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { mediaQueryUp } from 'components/utils/breakpoint'
import RecentSearchSuggestionItem from '../SearchForm/SearchLocationInput/RecentSearchSuggestionItem'

const StyledCaption = styled(Caption)`
  padding: 0;

  ${mediaQueryUp.tablet} {
    &:not(.horizontal) {
      padding: 0 ${rem(16)};
    }
  }
`

const RecentSearchItemContainer = styled.div`
  &.horizontal {
    display: flex;
    column-gap: ${rem(40)};
    flex-wrap: wrap;
    padding: 0;
  }
`

interface Props {
  recentSearches: Array<App.FullRecentSearch>
  onDelete?: (item: App.FullRecentSearch) => void
  selectedDropdown?: number
  onRecentSearchClick: (recentSearch: App.FullRecentSearch) => void
  horizontal?: boolean
  iconBackground?: boolean
  subtitleOptions?: {
    includeRooms?: boolean
  }
}

function ExperienceRecentSearchSuggestions(props: Props) {
  const {
    recentSearches,
    onDelete = noop,
    selectedDropdown,
    onRecentSearchClick,
    horizontal,
    iconBackground,
    subtitleOptions,
  } = props

  const intl = useIntl()

  const onDeleteClick = useCallback((recentSearch: App.FullRecentSearch) => {
    onDelete(recentSearch)
  }, [onDelete])

  return <>
    <StyledCaption variant="large" weight="bold" className={clsx({ horizontal })}>
      {intl.formatMessage({
        id: 'DVXeI0_xcLq4kvouIOU_',
        defaultMessage: 'Recent searches',
        description: 'Section heading for recent search suggestions section',
      })}
    </StyledCaption>
    <div data-testid="search-recent-searches">
      <RecentSearchItemContainer className={clsx({ horizontal })}>
        {recentSearches.map((recentSearch, index) => <RecentSearchSuggestionItem
          key={recentSearch.recentSearchId}
          selected={index === selectedDropdown}
          iconBackground={iconBackground}
          recentSearch={recentSearch}
          onClick={onRecentSearchClick}
          onDelete={onDeleteClick}
          horizontal={horizontal}
          subtitleOptions={subtitleOptions}
        />)}
      </RecentSearchItemContainer>
    </div>
  </>
}

export default ExperienceRecentSearchSuggestions
